module.exports = __webpack_public_path__ + "static/media/bg.b74b9f78.png";